import { render, staticRenderFns } from "./SyncPrompt.vue?vue&type=template&id=0777b79a&scoped=true"
import script from "./SyncPrompt.vue?vue&type=script&lang=js"
export * from "./SyncPrompt.vue?vue&type=script&lang=js"
import style0 from "./SyncPrompt.vue?vue&type=style&index=0&id=0777b79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0777b79a",
  null
  
)

export default component.exports